import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, message, Popconfirm, Popover, Space } from 'antd';
import React, { useState } from 'react';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import { PlusOutlined } from '@ant-design/icons';
import {
  deleteItemInsuranceEligibility,
  getItemInsuranceEligibility,
} from '../../../network/ItemEligibility';
import { queryKeys } from '../../../services/react-query/queryKeys';
import DynamicTableAnt from '../../../hooks/DynamicTableAnt';
import Heading from '../../common/Heading/Heading';
import { ModalAppItemEligibility } from '../ModalApp/ModalApp';
import StatusTag from '../../../hooks/StatusHook';

const ItemEligibility = ({ t }) => {
  const client = useQueryClient();
  const [searchText, setSearchText] = useState('');
  const [editId, setEditId] = useState('');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getItemInsuranceEligibility],
    queryFn: () => getItemInsuranceEligibility(),
    keepPreviousData: true,
  });
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deleteItemInsuranceEligibility(id),
      onSuccess: (data) => {
        // console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message);
          return false;
        }
        client.invalidateQueries({
          queryKey: [queryKeys.getItemInsuranceEligibility],
        });
        message.success('Deleted successfully');
        // message.success('تم الحذف بنجاح');
      },
      onError: () => {
        message.error('حدث خطأ ما');
      },
    }
  );
  const columns = [
    {
      title: t.itemCode,
      dataIndex: 'item_code',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        return String(record.item_code)
          .toLowerCase()
          .includes(value.toLowerCase());
      },
    },
    {
      title: t.insurancePlan,
      dataIndex: 'insurance_plan',
    },
    {
      title: t.modeOfApproval,
      dataIndex: 'mode_of_approval',
      render: (status) => {
        return <StatusTag status={status} />;
      },
    },
    {
      title: t.coverage,
      dataIndex: 'coverage',
    },
    {
      title: t.discount,
      dataIndex: 'discount',
    },
    {
      title: t.validFrom,
      dataIndex: 'valid_from',
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 150,
      render: (text, record) => {
        // console.log('record:', record);
        return (
          <Space>
            <Button
              size="small"
              type="primary"
              onClick={() => {
                setEdit(true);
                setOpen(true);
                setEditId(record.name);
              }}
              icon={<MdModeEditOutline />}
            />
            <Popconfirm
              title="Delete the Item Insurance Eligibility?"
              description="Are you sure to delete?"
              onConfirm={() => handleRemove.mutate(record.name)}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button size="small" type="primary" danger icon={<MdDelete />} />
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => ({
    key: index,
    ...item,
  }));
  return (
    <div className="eligibility">
      <Heading
        title={t.Insurances}
        subTitle={t.ItemEligibility}
        path="/item_eligibility"
      />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        // titleBtn={t.addEligibilityPlan}
        Placeholder={t.searchItemCode}
        // pathBtn="/add-patient"
        buttonModal={
          <Button
            type="primary"
            onClick={() => {
              setOpen(true);
              setEdit(false);
            }}
          >
            <PlusOutlined
              style={{
                fontSize: '10px',
              }}
            />{' '}
            {t.addItemEligibility}
          </Button>
        }
      />
      <ModalAppItemEligibility
        t={t}
        open={open}
        setOpen={setOpen}
        edit={edit}
        record={editId}
      />
    </div>
  );
};

export default ItemEligibility;
